import { html } from "../../../util/html.ts";

export type OpenGraphMetaLocals = {
  config: {
    meta?: {
      title?: string;
      siteName?: string;
      description?: string;
      twitterCardTag?: string;
      twitterSiteTag?: string;
      twitterCreatorTag?: string;
    };
  };
  meta?: {
    title?: string;
    description?: string;
    og: {
      image?: string;
    };
  };
  og?: {
    url?: string;
    image?: string;
    type?: string;
    namespace?: Record<string, string>[];
  };
  commonLinks?: {
    canonicalUrl?: string;
  };
};


export const openGraphMetaTags = (props: OpenGraphMetaLocals) => {
  const { config, meta, og, commonLinks } = props;
  const ogTitle = (meta?.title || config.meta?.title || '').replace(/&#?[a-z0-9]+;/g, '');

  return html`
    <meta property="fb:app_id" content="5885186655">
    <meta property="og:site_name" content="${ config.meta?.siteName }">
    <meta property="og:title" content="${ogTitle}">
    <meta property="og:description" content="${ meta?.description || config.meta?.description }">
    <meta property="og:url" content="${ og?.url }">
    <meta property="og:image" content="${ og?.image || meta?.og.image }">
    <meta property="og:type" content="${ og?.type }">
    <meta property="og:canonical" content="${ commonLinks?.canonicalUrl }">

    <meta property="twitter:card" content="${ config?.meta?.twitterCardTag }">
    <meta property="twitter:site" content="${ config?.meta?.twitterSiteTag }">
    <meta property="twitter:creator" content="${ config?.meta?.twitterCreatorTag }">
    <meta property="twitter:title" content="${ meta?.title || config?.meta?.title }">
    <meta property="twitter:description" content="${ meta?.description || config.meta?.description }">
    <meta property="twitter:img:src" content="${ og?.image }">

    ${ og?.namespace?.map(item => (
        html`<meta property="${ Object.keys(item)[0] }" content="${ item[Object.keys(item)[0] as keyof typeof item] }">`
    )) }

    <link rel="shortcut icon" href="/favicon.ico">
`;
}
